module.exports = __webpack_public_path__ + "static/img/cMRId3.00599c16.png";